import { Component, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MetadataProp } from '../../models/metadata-prop-model';
import { SearchComboItemModel } from '../../models/search-combo-item-model';
import { ConstantsService } from '../../services/constants.service';
import { FormsService } from '../../services/forms.service';
import { MetadataService } from '../../services/metadata.service';
import { QueryStateService } from '../../services/query-state.service';

@Component({
  selector: 'app-nav-top',
  templateUrl: './nav-top.component.html',
  styleUrls: ['./nav-top.component.css']
})
export class NavTopComponent implements OnInit {

  navItems: MenuItem[];
  helpInfoItems: MenuItem[];
  loadSearchVisible: boolean = false;

  mdItems?: MetadataProp[];
  searchForm: FormGroup;

  constructor(private formSvc: FormsService, private actRouter: ActivatedRoute,
    private router: Router,
    private queryStateSvc: QueryStateService,
    private constants: ConstantsService, private mdSvc: MetadataService) {

    this.searchForm = this.formSvc.initSearchForm();

    this.navItems = [
      {
        label: 'Home',
        icon: 'fas fa-home',
        url: '/landing'
      },
      {
        label: 'Advanced Search',
        icon: 'fa-brands fa-searchengin',
        url: '/adv-search'
      }, {
        label: 'Load Saved Search',
        icon: 'pi pi-upload',
        command: () => { this.loadSearch(); }
      }, {
        label: 'Help & Info',
        icon: 'fas fa-circle-question',
        items: [
          {
            label: "User Guide",
            icon: 'pi pi-book',
            url: '/assets/EHD-User-Manual.pdf',
            target: '_blank'
          },
          {
            label: "User Training Video",
            icon: 'fa fa-video-camera',
            url: 'https://www.youtube.com/watch?v=s4TvHNFp5Kg',
            target: '_blank'
          },
          {
            label: "Glossary",
            icon: 'fas fa-book-atlas',
            url: '/terms',
            target: '_blank'
          },
          {
            label: "ADAMS Public Search",
            icon: 'fa-solid fa-magnifying-glass',
            url: 'https://adams-search.nrc.gov/home',
            target: '_blank'
          },
          {
            label: "NRC.gov",
            icon: 'fa-regular fa-building',
            url: 'https://www.nrc.gov',
            target: '_blank'
          }
        ]
      },
    ]

    this.helpInfoItems = [
      {
        label: "User Guide",
        icon: 'pi pi-book',
        url: '/assets/EHD-User-Manual.pdf',
        target: '_blank'
      },
      {
        label: "User Training Video",
        icon: 'fa fa-video-camera',
        url: 'https://www.youtube.com/watch?v=s4TvHNFp5Kg',
        target: '_blank'
      },
      {
        label: "Glossary",
        icon: 'fas fa-book-atlas',
        url: '/terms',
        target: '_blank'
      },
      {
        label: "ADAMS Public Search",
        icon: 'fa-solid fa-magnifying-glass',
        url: 'https://adams-search.nrc.gov/home',
        target: '_blank'
      },
      {
        label: "NRC.gov",
        icon: 'fa-regular fa-building',
        url: 'https://www.nrc.gov',
        target: '_blank'
      }
    ];
  }

  ngOnInit(): void {
    this.mdSvc.mdData$.subscribe(data => { this.mdItems = data; });
  }

  goHome() {
    window.location.href = '/';
    // this.router.navigate(['/']);
  }

  goAdvSearch() {
    let sf = this.formSvc.initSearchForm();

    this.queryStateSvc.updateFormData(sf.value);
    // console.log(JSON.stringify(sf.value));
    this.router.navigate(['adv-search']);
  }

  loadSearch() {
    //show popup to load the search and execute the search.
    this.loadSearchVisible = true;
  }

  executeLoadSearch(query: any) {
    this.loadSearchVisible = false;
    this.queryStateSvc.updateFormData(query);

    this.router.navigate([
      '/results/' + encodeURIComponent(JSON.stringify(this.queryStateSvc.getFormData())),
    ]);
  }

  closeLoadSearch() {
    this.loadSearchVisible = false;
  }

  executeQuickDateSearch(startDate: string, endDate?: string) {
    let dateOp = this.constants.date_operator_equals;
    if (endDate) {
      dateOp = this.constants.date_operator_between;
    }

    //get the property Item Id
    let i = this.mdItems?.find((m) => m.cogSearchKey == 'DateAdded') as MetadataProp;
    let pid = '';
    if (i) {
      pid = i.id;
    }

    let data: SearchComboItemModel = {
      isDate: true,
      dateOperator: dateOp,
      displayName: "Date Added",
      propertyItem: pid,
      endDate: endDate,
      startDate: startDate,
      keywords: ''
    };


    let p = this.formSvc.updateDateProp(data);

    const allArray = this.searchForm.get(this.constants.property_operator_all) as FormArray;
    allArray.clear();  // Clear the other items since we are using a pre-canned query.
    allArray.push(p);

    // Reset the skip count in case we are coming from a page result that is larger than our result.
    this.queryStateSvc.updateSkipCount(0);

    // Update the form values in the query state service which drives functions
    this.queryStateSvc.updateFormData(this.searchForm.value); // Will update/create the Search request in the Query Service.
    // console.log('form: ' + JSON.stringify(this.searchForm.value));

    this.router.navigate([
      '/results/' + encodeURIComponent(JSON.stringify(this.queryStateSvc.getFormData())),
    ]);
  }

  switchLibrary() {
    //TODO: switch based on the environment variable.
  }

  searchDays(daysBack: number) {

    let d = new Date();
    const finalDate = new Date(d);
    finalDate.setDate(d.getDate() - daysBack);

    let start = finalDate.toISOString().substring(0, 10);
    let end = d.toISOString().substring(0, 10);

    // If today or yesterday then just use the one date which will use equals operator.
    if (daysBack < 2) {
      this.executeQuickDateSearch(start);
    }
    else {
      this.executeQuickDateSearch(start, end);
    }
  }
}
